import type { AdminUser } from './api.js';

export type LoginStage = 'LOGIN' | 'PASSWORD' | 'SETUP' | 'MFA';

export function initialLoginStage(
  user: Pick<AdminUser, 'must_change_password' | 'mfa_enabled'> | null,
): LoginStage {
  if (!user) return 'LOGIN';
  if (user.must_change_password) return 'PASSWORD';
  return user.mfa_enabled ? 'MFA' : 'SETUP';
}
